export default __webpack_public_path__ + "static/media/FIAssembly-07.3eb14238.png";